/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import React from 'react';
import BreadCrumbs from '../core/BreadCrumbs';
import CaseViewLoader from '../core/Loaders/CaseViewLoader';
import { useGetInvoice } from '../../hooks/invoice/useGetInvoice';
import InvoiceDetails from './InvoiceForm';
const BREAD_CRUMBS = [
  { label: 'Invoice', to: '/user/invoicelist' },
  { label: 'Invoice Edit', to: '/user/invoice/edit' },
];

const EditInvoice = () => {
  const { data, loading: fetchingDetails } = useGetInvoice();

  return (
    <>
      <BreadCrumbs items={BREAD_CRUMBS} />
      <div className="row card">
        <div className="invoices-tabs-card">
          <div className="card-body">
            {fetchingDetails ? (
              <CaseViewLoader />
            ) : (
              <InvoiceDetails data={data}/>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default EditInvoice;
